import CartPrivilegeItemListPrice from './Price'
import { CleanButton, Icon, Image, Link } from '@components/gassan-ui'
import { Heading } from '@components/gassan-ui/Typography/Heading'
import { PrivilegeCartItem } from '@generated'
import { imgix } from '@lib/imigx'
import { motion } from 'framer-motion'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { cn } from '@lib/cn'

type CartPrivilegeItemListItemProps = PrivilegeCartItem & {
  onRemove: (id: string) => void
}

export const CartPrivilegeItemListItem: FC<CartPrivilegeItemListItemProps> = ({
  onRemove,
  imageSource,
  description,
  value,
  id,
}) => {
  const { t } = useTranslation('other')
  return (
    <motion.div
      animate
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className="last:mb-[-1px] last:[&>[data-privilege-item]]:!mb-0"
    >
      <div
        className={cn(
          'row-span-2 mb-16 grid grid-cols-[3.75rem_1fr] gap-x-4 border-b border-shade-200 pb-16',
          'sm:mb-28 sm:grid-cols-[10.5rem_1fr_7rem] sm:pb-28',
          'lg:grid-cols-[6rem_1fr_7rem]',
          'xl:mb-32 xl:grid-cols-[11rem_1fr_7rem] xl:pb-32',
          'xxl:gap-x-40',
        )}
        data-privilege-item
      >
        <div className="relative bg-shade-100 pt-[100%]">
          {imageSource && (
            <Image
              className="absolute inset-0 bg-shade-100"
              sources={[imgix(imageSource, { width: 177 })]}
              alt={description}
            />
          )}
        </div>
        <div className="flex flex-col">
          <div className="flex items-center justify-between">
            <Heading className="mb-0 sm:mb-2 xl:mb-4" variant="h4" as="h4">
              {description}
            </Heading>

            <div className="contents text-tabaccoBrown sm:hidden">
              <CleanButton onClick={() => onRemove(id)} color="tabaccoBrown">
                <Icon icon="trash-can" />
              </CleanButton>
            </div>
          </div>
          <div className="hidden sm:contents">
            <Link
              as="button"
              onClick={() => onRemove(id)}
              variant="brown"
              style={{ width: 'fit-content' }}
            >
              {t('remove')}
            </Link>
          </div>
        </div>
        <div className="hidden sm:contents">
          <CartPrivilegeItemListPrice price={value} />
        </div>
        <div className="col-start-2 sm:col-auto">
          <div className="contents sm:hidden">
            <CartPrivilegeItemListPrice price={value} />
          </div>
        </div>
      </div>
    </motion.div>
  )
}
